<template>
  <div class="container">
    <div class="row no-mar">
      <div class="col-12">
        <h1 class="itemoverview-header">{{ $t("configureANewPassword") }}</h1>
        <p v-if="validURL">
          {{ $t("useTheFormBelowToConfigureYourNewPassword") }}
        </p>
        <p v-else>{{ $t("thePasswordLinkIsInvalidOrHasExpired") }}</p>
        <password-reset-form
          v-if="validURL"
          :userid="userid"
          :username="username"
          :code="code"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PasswordResetForm from "./PasswordResetForm"
export default {
  components: {
    PasswordResetForm,
  },
  data: function () {
    return {
      userid: null,
      username: null,
      code: null,
    }
  },
  computed: {
    validURL: function () {
      if (this.userid === null) return false
      if (this.code === null) return false
      return true
    },
  },
  created: function () {
    this.userid = new URLSearchParams(window.location.search).get("UserID")
    this.code = new URLSearchParams(window.location.search).get("Code")
  },
}
</script>

<style></style>
